"use client";

import React from "react";
import Image from "next/image";
import styles from "./CityListItem.module.scss";
import assetLoader from "@utils/internalImageLoder";
import { trackEventWithCommonProps, EventType } from "@utils/eventTracker";
import { getSelectedCityClient } from "@helpers/client/getSelectedCity";

interface CityListItemProps {
  city: any;
  selectedCity?: any;
  onSelect: (city: any) => void;
  pageType?: string,
}

const CityListItem = ({ city, selectedCity, onSelect, pageType }: CityListItemProps) => {
  const isSelected = selectedCity?.id === city.id;

  const handleCitySelect = async () => {
    // Track city selection
    const currentSelectedCity = getSelectedCityClient();
    await trackEventWithCommonProps("action", EventType.TRACK_EVENT, {
      pageType: pageType,
      additionalProps: {
        action_type: "tap_btn",
        action_name: "tap_btn_city_selected",
        selected_city: city.name,
        city_name: currentSelectedCity?.name || "",
      },
    });

    onSelect(city);
  };

  return (
    <div className={styles.cityListItemWrapper}>
      <button onClick={handleCitySelect} className={styles.cityListItem}>
        <span className={styles.cityListName}>{city.name}</span>
        <Image
          src={`${assetLoader()}/icons/chevron_right_dark.svg`}
          alt="Select"
          width={16}
          height={16}
          className={styles.cityChevronIcon}
        />
      </button>
      <div className={styles.divider} />
    </div>
  );
};

export default CityListItem;
